import { GET_ADMIN_CHANGE_HISTORY, GET_ADMIN_CHANGE_HISTORY_EXPORT } from "./actionTypes"
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"
import { getAdminChangeHistoryError, getAdminChangeHistoryExportError, getAdminChangeHistoryExportSuccess, getAdminChangeHistorySuccess } from "./actions"
import { genericGetRequest_2 } from "../../helpers/sf_backend_helper";
import { AppConfiguration } from "config";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";
import ToastAlert, { ToastAlertIconType } from "components/Common/ToastAlert/ToastAlert";
import { buildChangeHistoryCacheKey } from "helpers/change_history_pagination_helper";
import { showExportEnqueuedToast } from "helpers/export_toast_helper";

const inFlightAdminChangeHistoryRequests = new Set()

const buildAdminChangeHistoryRequestKey = (queryParams = {}) =>
  JSON.stringify(queryParams)

function* onGetAdminChangeHistory(action) {
  const queryParams = action.payload?.queryParams || {}
  const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
  const requestKey = buildAdminChangeHistoryRequestKey(queryParams)

  if (inFlightAdminChangeHistoryRequests.has(requestKey)) {
    return
  }

  try {
    let user_auth = bsh_getAdminUserDetails();
    const useCache = Boolean(action.payload?.useCache)
    const cacheKey = useCache ? buildChangeHistoryCacheKey(queryParams) : null
    const cachedPage = useCache
      ? yield select((state) => state.AdminChangeHistory.page_cache?.[cacheKey]?.[requestedPageNumber])
      : null

    if (useCache && cachedPage) {
      return
    }

    inFlightAdminChangeHistoryRequests.add(requestKey)

    const response = yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_history_versions`,
      queryParams,
      {
        Authorization: user_auth.token,
        'account-id': user_auth.account_id
      }
    )
    yield put(getAdminChangeHistorySuccess(response, {
      queryParams,
      appendResults: Boolean(action.payload?.appendResults),
      useCache,
    }))
  } catch (error) {
    yield put(getAdminChangeHistoryError(error))
  } finally {
    inFlightAdminChangeHistoryRequests.delete(requestKey)
  }
}

function* onGetAdminChangeHistoryExport(action) {
  try {
    let user_auth = bsh_getAdminUserDetails();
    yield call(
      genericGetRequest_2,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_history_versions_export`,
      action.payload?.queryParams,
      {
        Authorization: user_auth.token
      }
    )
    yield put(getAdminChangeHistoryExportSuccess())
    showExportEnqueuedToast({ reportExportsAvailable: true });
  } catch (error) {
    yield put(getAdminChangeHistoryExportError())
    ToastAlert.fire({ icon: ToastAlertIconType.ERROR, title: 'Export failed due to some unexpected error' });
  }
}

function* adminChangeHistorySaga() {
  yield takeLatest(GET_ADMIN_CHANGE_HISTORY, onGetAdminChangeHistory);
  yield takeEvery(GET_ADMIN_CHANGE_HISTORY_EXPORT, onGetAdminChangeHistoryExport);
}

export default adminChangeHistorySaga;
